"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalDataProvider = void 0;
const useSearchQueryParam_1 = require("root/src/client/v2/common/hooks/useSearchQueryParam");
function GlobalDataProvider(props) {
    // TODO move it to more suitable place
    const [logoutParam, setLogoutParam] = (0, useSearchQueryParam_1.useSearchQueryParam)({
        param: 'logout',
        disableParamsReplace: true,
    });
    if (logoutParam === 'true') {
        setLogoutParam(null);
    }
    return <>{props.children}</>;
}
exports.GlobalDataProvider = GlobalDataProvider;
